import React from "react";
import { Link } from "react-router-dom";
import CustomLink from "./custom-link";

const DesktopNav = () => {
  return (
    <nav className="desktop-nav-container">
      <div className="desktop-nav-logo-container">
        <div className="desktop-nav-logo">
          <img src={require("../assets/images/res-logo.png")} alt="logo" />
          <span className="desktop-nav-logo-title">Deccan <span>Express</span></span>
        </div>
      </div>
      <div className="desktop-nav-links-container">
        <ul>
          <CustomLink to="/">Home</CustomLink>
          <CustomLink to="/menu">Menu</CustomLink>
          <CustomLink to="/contact-us">Contact Us</CustomLink>
        </ul>
      </div>
    </nav>
  );
};

export default DesktopNav;
